import { render, staticRenderFns } from "./utmReportList.vue?vue&type=template&id=0cf31bb9"
import script from "./utmReportList.vue?vue&type=script&lang=js"
export * from "./utmReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports